<template>
  <div>
    <v-btn color="primary" outlined rounded small @click="open">
      <v-icon left small>mdi-sort</v-icon>
      Arrange Category
    </v-btn>

    <v-dialog v-model="dialog" max-width="650" persistent>
      <v-card class="arrange-category-card">
        <v-toolbar
          dense
          flat
          color="grey lighten-4"
          class="arrange-category-header"
        >
          <v-toolbar-title class="subtitle-1">
            Arrange Remote Order Categories
          </v-toolbar-title>

          <v-spacer />

          <v-btn icon small @click="close">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="arrange-category-body">
          <v-alert dense outlined type="info" class="mb-4">
            Drag categories to set the order customers see on the order link.
          </v-alert>

          <v-skeleton-loader
            v-if="loading"
            type="list-item-three-line, list-item-three-line, list-item-three-line"
          />

          <div v-else>
            <draggable
              v-model="categories"
              handle=".drag-handle"
              animation="180"
            >
              <v-card
                v-for="(category, index) in categories"
                :key="category.id"
                outlined
                class="category-sort-row mb-2"
              >
                <div class="sort-number">{{ index + 1 }}</div>

                <v-icon class="drag-handle mr-3">mdi-drag</v-icon>

                <v-avatar size="38" tile class="mr-3 category-image">
                  <v-img
                    v-if="category.imageUrl"
                    :src="category.imageUrl"
                    contain
                  />
                  <v-icon v-else small color="grey">mdi-shape-outline</v-icon>
                </v-avatar>

                <div class="category-info">
                  <div class="font-weight-medium">
                    {{ category.name }}
                  </div>
                  <div class="caption grey--text">
                    ID: {{ category.localId || category.id }}
                  </div>
                </div>

                <!-- <v-spacer />

                <v-chip
                  x-small
                  label
                  :color="
                    category.remoteOrder ? 'green lighten-4' : 'grey lighten-3'
                  "
                  :text-color="
                    category.remoteOrder ? 'green darken-3' : 'grey darken-2'
                  "
                >
                  {{ category.remoteOrder ? "Remote" : "Hidden" }}
                </v-chip> -->
              </v-card>
            </draggable>

            <v-alert v-if="!categories.length" dense outlined type="warning">
              No categories found.
            </v-alert>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="arrange-category-footer">
          <v-spacer />
          <v-btn text @click="close">Cancel</v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="loading || !categories.length"
            @click="save"
          >
            Save Order
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import categroyService from "@/modules/Product/Category/service.js";

export default {
  name: "ArrangeCategoryOrder",
  components: {
    draggable,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      saving: false,
      categories: [],
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.getList();
    },

    close() {
      if (this.saving) return;
      this.dialog = false;
    },

    getList() {
      this.loading = true;

      return categroyService
        .getAll()
        .then((response) => {
          // console.log('response', response)
          const rows = response.data || [];

          // console.log(
          //   "Category Sort Orders",
          //   rows.map((c) => ({
          //     id: c.id,
          //     name: c.name,
          //     sortOrder: c.sortOrder,
          //   }))
          // );

          this.categories = rows.slice().sort((a, b) => {
            const aOrder = parseInt(a.sortOrder, 10);
            const bOrder = parseInt(b.sortOrder, 10);

            const aHasOrder = !isNaN(aOrder) && aOrder > 0;
            const bHasOrder = !isNaN(bOrder) && bOrder > 0;

            // Categories with sortOrder come first
            if (aHasOrder && bHasOrder) {
              return aOrder - bOrder;
            }

            if (aHasOrder) return -1;
            if (bHasOrder) return 1;

            // Fallback when neither has sortOrder
            return String(a.name || "").localeCompare(String(b.name || ""));
          });

          console.log(
            "Sorted Categories",
            this.categories.map((c) => ({
              id: c.id,
              name: c.name,
              sortOrder: c.sortOrder,
            }))
          );

          return response;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      this.saving = true;

      const payload = this.categories.map((category, index) => ({
        id: category.id,
        sortOrder: index + 1,
      }));

      return categroyService
        .updateSortOrder(payload)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Category order saved",
            });

          this.dialog = false;
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.category-sort-row {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 12px;
}

.sort-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
}

.drag-handle {
  cursor: grab;
}

.category-image {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.category-info {
  min-width: 0;
}

.arrange-category-card {
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.arrange-category-header {
  flex: 0 0 auto;
}

.arrange-category-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 16px !important;
}

.arrange-category-footer {
  flex: 0 0 auto;
  background: #ffffff;
}
</style>